import React from 'react';

import { AccordionBlock } from '@/app/_components/AccordionBlock';
import { AccordionBlockProps } from './types';

import classes from './index.module.scss';

export const AccordionBlockGraphQL: React.FC<AccordionBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <AccordionBlock accordionBlock={props} />
    </div>
  );
};

export default AccordionBlockGraphQL;
